export default __webpack_public_path__ + "static/media/Eye.63a34dbe.svg";